import { atom } from "recoil";

export const userSession = atom({
  key: "userSession",
  default: null,
});
